import script from "./DigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./DigitalSignatureForm.vue?vue&type=style&index=0&id=204af9e9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-204af9e9"]])

export default __exports__